import { Space } from '@billy/design-system'
import { Icon, Typography, XStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { Backpack } from 'lucide-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface PromoCalloutProps {
  isFreePlanAudience: boolean
}

export const PromoCallout = ({ isFreePlanAudience }: PromoCalloutProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.PromoCalloutWrapper>
      <XStack align="center" gap={8}>
        <Icon color={colors.content.highlight.cyan.bold} icon={Backpack} size="small" />
        <Typography.Text color={colors.content.highlight.cyan.bold} size="small" weight="semibold">
          {isFreePlanAudience
            ? t('navigation.menu.footer.trial_status_banner.back_to_school_header.free')
            : t('navigation.menu.footer.trial_status_banner.back_to_school_header.trial')}
        </Typography.Text>
      </XStack>
      <Space size="s8" />
      <Typography.Text color={colors.content.highlight.cyan.bold} size="small">
        {isFreePlanAudience
          ? t('navigation.menu.footer.back_to_school.subtitle.free')
          : t('navigation.menu.footer.back_to_school.subtitle.trial')}
      </Typography.Text>
    </Styled.PromoCalloutWrapper>
  )
}
